"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControlledPopover = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var typestyle_1 = require("typestyle");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var Styles_1 = require("../Styles");
function TriggerElement(_a) {
    var onClick = _a.onClick, testId = _a.testId, title = _a.title, props = __rest(_a, ["onClick", "testId", "title"]);
    switch (props.kind) {
        case 'inline-alert-props':
            return (react_1.default.createElement(widgets_1.CompactInlineAlertWidget, __assign({}, props, { style: { display: 'inline-flex' }, onClick: onClick, testId: testId }), title));
        case 'button-props':
            return (react_1.default.createElement(widgets_1.ButtonWidget, __assign({}, props, { buttonType: widgets_1.ButtonType.IconOutline, onClick: onClick, testId: testId })));
    }
}
function useControlledPopover(params) {
    var testId = params.testId, controlKind = params.controlKind, popoverProps = params.popoverProps, chipProps = params.chipProps, iconProps = params.iconProps, Content = params.content, loading = params.loading, props = params.props, onClick = params.onClick;
    var controlTestId = "".concat(testId, "-controlled-popover");
    var popoverInstance = react_1.default.useRef(null);
    var _a = react_1.default.useState(null), triggerElementProps = _a[0], setTriggerElementProps = _a[1];
    var mounted = react_1.default.useRef(false);
    react_1.default.useEffect(function () {
        mounted.current = true;
        return function () { mounted.current = false; };
    }, []);
    react_1.default.useEffect(function () {
        switch (controlKind) {
            case 'icon':
                setTriggerElementProps(iconProps(props));
                break;
            case 'chip':
                setTriggerElementProps(chipProps(props));
                break;
            default:
                (0, TypescriptHelpers_1.assertUnreachable)(controlKind);
        }
    }, [chipProps, controlKind, iconProps, props]);
    var triggerElement = (triggerElementProps ? react_1.default.createElement(TriggerElement, __assign({ testId: testId, title: popoverProps.title, onClick: onClick }, triggerElementProps)) : react_1.default.createElement(react_1.default.Fragment, null));
    var popover = triggerElement ? (react_1.default.createElement(widgets_1.PopoverWidget, __assign({}, popoverProps, { className: (0, typestyle_1.style)(Styles_1.LabelPopoverStyle), popoverContent: react_1.default.createElement(Content, { resolved: props, loading: loading }), triggerElement: triggerElement, ref: popoverInstance, testId: controlTestId, width: Styles_1.LabelPopoverWidth, placement: 'bottom-start' }))) : null;
    return popover;
}
exports.useControlledPopover = useControlledPopover;
//# sourceMappingURL=useControlledPopover.js.map